<div class="item-lines">
	<div class="item-line" *ngFor="let line of items" [ngClass]="{'not-exist': !line.id}">
		<ng-container>
			<div class="minus-button-block" matRipple [matRippleCentered]="true">
				<div class="minus-icon" (click)="deleteLine(line.id)">
					<span class="material-icons">
						remove_circle
					</span>
				</div>
			</div>
			<div class="info-line-block" matRipple (click)="openLineEditor(line)">
				<div class="info-line-header">
					<div class="left-line">{{line.salesItemLineDetail?.itemRef?.name}}</div>
					<div class="right-line">{{line.amount | number:'1.2-2'}}</div>
				</div>
				<div class="info-line-counter">
					{{line.salesItemLineDetail?.qty | number:'1.2-2'}} x
					{{line.salesItemLineDetail?.unitPrice | number:'1.2-2'}} each
				</div>
				<div class="info-line-class">
					Class: {{line.salesItemLineDetail?.classRef?.name}}
				</div>
				<div class="info-line-description">
					{{line.description}}
				</div>
			</div>
		</ng-container>
	</div>
</div>

<div class="add-button" (click)="addLines()">
	<div class="plus-button-block">
		<div class="plus-icon">
			<span class="material-icons">
				add_circle
			</span>
		</div>
	</div>
	<div class="info-line-block">
		<div class="info-line-header">
			Add product or service
		</div>
	</div>
</div>